export const content = {
    groups: [
        {title: 'Investment', items: [{title: 'Knowledge Base', to: 'articles'}, {title:'Market Overview', to: 'marketoverview'}]},
    ]
}